import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { NewsListResponse, NewsCategory } from "@/types/news"
import newsService from "@/service/news-service"

interface UseNewsListParams {
  page?: number
  pageSize?: number
  category?: NewsCategory
  options?: UseQueryOptions<NewsListResponse>
}

export function useNewsList({
  page = 1,
  pageSize = 20,
  category,
  options,
}: UseNewsListParams = {}) {
  return useQuery<NewsListResponse>({
    queryKey: ["news", "list", page, pageSize, category],
    queryFn: () => newsService.getNewsList(page, pageSize, category),
    ...options,
  })
}

